import { http } from "@/domains/common/utils/http/axios";
import type { BaseResponse } from "@/models/common/types/BaseResponse";
import { LoginResponse, LoginPayload } from "../type/login";

export const login = (params?: LoginPayload) => {
  return http.post<BaseResponse<LoginResponse>>("/api/bill/auth/login", params);
};
